module.exports = __webpack_public_path__ + "static/media/img_wear-insert-04.5c803968.svg";